import './loan-archive-log.component.scss'
import {Page, Pageable} from "../../../utils/models/Page";
import {ArchivedLoanLog} from "../../../loan_archive/model/ArchivedLoanLog";
import {LoanArchiveServiceName} from "../../../utils/names/serviceNames";
import {LoanArchiveService} from "../../../loan_archive/service/LoanArchiveService";
import {Borrower} from "../../../customers/model/Borrower";
import {LoaderOptions} from "../../../loader/model/LoaderOptions";
import {IPromise} from "angular";
import {ArchivedLoanDetailsDialog} from "../../dialog/archived-loan-details/archived-loan-details.dialog.component";

export class LoanArchiveLogComponent {
    static instance = {
        template: require('./loan-archive-log.component.html'),
        controller: [
            '$mdDialog',
            LoanArchiveServiceName,
            LoanArchiveLogComponent
        ],
        bindings: {
            borrower: '<',
        },
        controllerAs: '$ctrl'
    };

    private borrower: Borrower;
    private logs: ArchivedLoanLog[];
    private total: number;
    private pagingConfig: Pageable;
    private loaderOptions: LoaderOptions = {
        showLoader: true
    };

    public static readonly INITIAL_PAGE_SIZE = 10;

    constructor(private $mdDialog: angular.material.IDialogService,
                private loanArchiveService: LoanArchiveService) {
    }

    $onInit() {
        this.initPagingConfig();
        this.initBorrowerLogs();
    }

    private initPagingConfig() {
        this.pagingConfig = {
            page: 1,
            pageSize: LoanArchiveLogComponent.INITIAL_PAGE_SIZE,
            totalElements: this.total,
            fetchPage: this.fetchBorrowerLogs
        }
    }

    private initBorrowerLogs() {
        this.fetchBorrowerLogs()
            .then(() => this.loaderOptions.showLoader = false);
    }

    fetchBorrowerLogs = (): IPromise<Page<ArchivedLoanLog>> => {
        return this.loanArchiveService.fetchLogs(this.borrower, this.pagingConfig.page - 1, this.pagingConfig.pageSize)
            .then(logsPage => {
                this.handleLogsUpdate(logsPage);
                return logsPage;
            })
    }

    private handleLogsUpdate(logsPage: Page<ArchivedLoanLog>) {
        this.logs = logsPage.content;
        this.pagingConfig.pageSize = logsPage.size;
        this.pagingConfig.page = logsPage.number + 1;
        this.pagingConfig.totalElements = logsPage.totalElements;
    }

    showArchivedLoanDetails = (log: ArchivedLoanLog) => {
        this.loaderOptions.showLoader = true;
        this.loanArchiveService.fetchLogDetails(log)
            .then(archivedLoan => {
                this.loaderOptions.showLoader = false;
                let dialog = ArchivedLoanDetailsDialog.instance(archivedLoan);
                this.$mdDialog.show(dialog)
            });
    }
}